import { render, staticRenderFns } from "./editGlobalSearch.vue?vue&type=template&id=a7ff0a34&"
import script from "./editGlobalSearch.vue?vue&type=script&lang=js&"
export * from "./editGlobalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports